import { setFaroView } from '@foldland/vercel-observability/client'
import { useEffect } from 'react'

interface FaroRouteViewProps {
  route: string
}

export default function FaroRouteView({ route }: FaroRouteViewProps) {
  useEffect(() => {
    setFaroView(route)
  }, [route])

  return null
}
